export default "/images/vendor/flag-icons/flags/4x3/as.svg?f1d3fa0ae5d614eb16dda7f4b8d4ef03";